module.exports = __webpack_public_path__ + "Icono_Perfil-Bco_126px.png";